/** Skip cold-start session bootstrap on public auth pages (login runs bootstrap after sign-in). */
export function shouldSkipColdSessionBootstrap(pathname: string): boolean {
  const path = pathname.toLowerCase();
  if (path === '/register' || path.startsWith('/register/')) {
    return true;
  }
  if (path.includes('forgot-password') || path.includes('reset-password')) {
    return true;
  }
  if (path === '/login' || path === '/sign-in' || path.endsWith('/login') || path.endsWith('/sign-in')) {
    return true;
  }
  if (path === '/oauth/callback' || path === '/identity/oauth/callback') {
    return true;
  }
  return false;
}

/** True when session init finished and workspace headers can be sent for scoped APIs. */
export function isWorkspaceApiReady(
  sessionLoaded: boolean,
  sessionLoading: boolean,
  companyCount: number,
  selectedCompanyId: number | null | undefined,
): boolean {
  if (!sessionLoaded || sessionLoading) {
    return false;
  }
  if (companyCount <= 1) {
    return true;
  }
  return selectedCompanyId != null;
}

/** True while session init must complete before protected routes render (cold restore or post-login bootstrap). */
export function isSessionRestorePending(
  initialized: boolean,
  sessionLoading: boolean,
  sessionLoaded: boolean,
  isAuthenticated: boolean,
  workspaceApiReady = true,
): boolean {
  if (!initialized) {
    return true;
  }
  if (!isAuthenticated) {
    return false;
  }
  if (sessionLoaded && workspaceApiReady) {
    return false;
  }
  return sessionLoading || !sessionLoaded || !workspaceApiReady;
}
